<div class="header-layout" *ngIf="nome$">
  <p>Olá, {{ nome$ | async }} | {{ empresaName$ | async }}</p>
  <button class="btn" (click)="sendTo()">Trocar de Empresa</button>
</div>
